import { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useParams } from "react-router-dom";
import { Label, TextInput, Card } from "flowbite-react";
import { useGetData } from "../../../../../hooks/useGetData";
import { API } from "../../../../../global/global";
import Semaforo from "../../../../../img/Semaforo.png";
import Rojo from "../../../../../img/Rojo.png";
import Amarillo from "../../../../../img/Amarillo.png";
import Verde from "../../../../../img/Verde.png";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechaSocioeconomicaInterface } from "../../../../../interfaces/FechaSocioeconomicaInterface";
import { ConclusionLlenadaSEInterface } from "../../../../../interfaces/ConclusionLlenadaSEInterface";
import HeaderPrint from "../../../../../components/HeaderFormsPrint/HeaderFormsPrint";
import fotoMapa from "../../../../../img/fotoMapa.png";

export const EvaluacionPatrimonial1ListaPrint = () => {
  const tituloFormulario = "EVALUACIÓN PATRIMONIAL 1";
  const { control, reset, getValues } = useForm();
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const [edad, setEdad] = useState<number | null>(null);
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);

  const [formData, setFormData] = useState({});

  const imageUrl = `http://localhost:8000/storage/evaluados/photos/${evaluadosList_id}/Croquis.png`;

  const buildIntegrantesText = () => {
    const hijos = Number(queryEvaluado.data?.cuantos_hijos) || 0;
    const edades = [
      queryEvaluado.data?.edad_hijo1,
      queryEvaluado.data?.edad_hijo2,
      queryEvaluado.data?.edad_hijo3,
      queryEvaluado.data?.edad_hijo4,
    ].filter((edad) => edad);

    let texto = `${hijos} hijo${hijos !== 1 ? "s" : ""}`;

    if (edades.length > 0) {
      texto += ` de ${edades.join(", ")} años`;
    }

    return texto;
  };

  const handleInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const handleFechaNacimientoChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const nuevaFechaNacimiento = event.target.value;
    setFechaNacimiento(nuevaFechaNacimiento);

    const nuevaEdad = calcularEdad(nuevaFechaNacimiento);
    setEdad(nuevaEdad);
  };

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryFechaSE = useGetData<FechaSocioeconomicaInterface[]>({
    url: `/fecha-socioeconomica/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "fecha-socioeconomica"],
  });

  const queryEvaluacionSE = useGetData<ConclusionLlenadaSEInterface>({
    url: `/conclusionllenada_se/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "conclusionllenada_se"],
  });

  const generoMap: { [key: string]: string } = {
    M: "Masculino",
    F: "Femenino",
    O: "Otro",
  };

  const normalizeString = (str: string) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const nombreCompleto = normalizeString(
    `${queryEvaluado.data?.nombre}_${queryEvaluado.data?.apellido_paterno}_${queryEvaluado.data?.apellido_materno}`.replace(
      /\s/g,
      "_"
    )
  );

  const [selectedImage, setSelectedImage] = useState(Semaforo);
  const [selectedRecommendation, setSelectedRecommendation] = useState<
    string | null
  >(null);

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSelectedRecommendation(value);

    if (value === "recomendable") {
      setSelectedImage(Verde);
    } else if (value === "con_reserva") {
      setSelectedImage(Amarillo);
    } else if (value === "no_recomendable") {
      setSelectedImage(Rojo);
    }
  };

  const generoTexto =
    generoMap[queryEvaluado.data?.genero as string] || "No especificado";

  useEffect(() => {
    console.log(queryEvaluado.data);
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      setEdad(nuevaEdad);

      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: queryEvaluado.data.fecha_nacimiento || "",
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  useEffect(() => {
    if (evaluadosList_id) {
      const token = localStorage.getItem("token");
      fetch(`${API}/evaluados/${evaluadosList_id}/photo/${nombreCompleto}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.url) {
            setPhotoUrl(data.url);
            console.log("URL de la foto:", data.url);
          } else {
            setPhotoUrl(null);
          }
        })
        .catch((error) => {
          console.error("Error al obtener la URL de la foto:", error);
          setPhotoUrl(null);
        });
    }
  }, [evaluadosList_id, nombreCompleto]);

  useEffect(() => {
    if (queryFechaSE.data && queryFechaSE.data.length > 0) {
      const fechaps = queryFechaSE.data[0];
      reset({
        fecha_evaluacionse: fechaps.fecha_evaluacionse || "",
      });
    }
  }, [queryFechaSE.data, reset]);

  useEffect(() => {
    if (queryEvaluacionSE.data) {
      console.log("Datos cargados:", queryEvaluacionSE.data);
      reset({
        derivado_se: queryEvaluacionSE.data.derivado_se || "",
        regimen_se: queryEvaluacionSE.data.regimen_se || "",
        anioscasado_se: queryEvaluacionSE.data.anioscasado_se || "",
        numhijos_se: queryEvaluacionSE.data.numhijos_se || "",
        edadhijos_se: queryEvaluacionSE.data.edadhijos_se || "",
        numdependientes_se: queryEvaluacionSE.data.numdependientes_se || "",
        quienesdependen_se: queryEvaluacionSE.data.quienesdependen_se || "",
        aniostrabajando_se: queryEvaluacionSE.data.aniostrabajando_se || "",
        areapertenece_se: queryEvaluacionSE.data.areapertenece_se || "",
        fechalaborando_se: queryEvaluacionSE.data.fechalaborando_se || "",
        enterovacante_se: queryEvaluacionSE.data.enterovacante_se || "",
        recomendo_se: queryEvaluacionSE.data.recomendo_se || "",
        gastoalimentacion_se: queryEvaluacionSE.data.gastoalimentacion_se || "",
        gastovestido_se: queryEvaluacionSE.data.gastovestido_se || "",
        gastogasolina_se: queryEvaluacionSE.data.gastogasolina_se || "",
        gastotransporte_se: queryEvaluacionSE.data.gastotransporte_se || "",
        gastotelefono_se: queryEvaluacionSE.data.gastotelefono_se || "",
        gastodiversiones_se: queryEvaluacionSE.data.gastodiversiones_se || "",
        gastoautofinanciamiento_se:
          queryEvaluacionSE.data.gastoautofinanciamiento_se || "",
        gastootros1_se: queryEvaluacionSE.data.gastootros1_se || "",
        gastohipoteca_se: queryEvaluacionSE.data.gastohipoteca_se || "",
        gastorenta_se: queryEvaluacionSE.data.gastorenta_se || "",
        gastocolegiaturas_se: queryEvaluacionSE.data.gastocolegiaturas_se || "",
        gastoservicios_se: queryEvaluacionSE.data.gastoservicios_se || "",
        gastodeudas_se: queryEvaluacionSE.data.gastodeudas_se || "",
        gastoinversiones_se: queryEvaluacionSE.data.gastoinversiones_se || "",
        gastopension_se: queryEvaluacionSE.data.gastopension_se || "",
        gastootros2_se: queryEvaluacionSE.data.gastootros2_se || "",
        gastototal_se: queryEvaluacionSE.data.gastototal_se || "",
        ingresomensual_se: queryEvaluacionSE.data.ingresomensual_se || "",
        compuestopor_se: queryEvaluacionSE.data.compuestopor_se || "",
        ingresoesposa_se: queryEvaluacionSE.data.ingresoesposa_se || "",
        ingresosextra_se: queryEvaluacionSE.data.ingresosextra_se || "",
        ascienden_se: queryEvaluacionSE.data.ascienden_se || "",
        egresosfam_se: queryEvaluacionSE.data.egresosfam_se || "",
        compuestosde_se: queryEvaluacionSE.data.compuestosde_se || "",
        esposaegreso_se: queryEvaluacionSE.data.esposaegreso_se || "",
        deudasascienden1_se: queryEvaluacionSE.data.deudasascienden1_se || "",
        gastosaprox_se: queryEvaluacionSE.data.gastosaprox_se || "",
        deudasascienden2_se: queryEvaluacionSE.data.deudasascienden2_se || "",
        cuantosvehiculos_se: queryEvaluacionSE.data.cuantosvehiculos_se || "",
        marcavechiculo_se: queryEvaluacionSE.data.marcavechiculo_se || "",
        aniovehiculo_se: queryEvaluacionSE.data.aniovehiculo_se || "",
        adquiriovehiculo_se: queryEvaluacionSE.data.adquiriovehiculo_se || "",
        domicilioactual_se: queryEvaluacionSE.data.domicilioactual_se || "",
        tiempoviviendo_se: queryEvaluacionSE.data.tiempoviviendo_se || "",
        referenciavecinal1_se:
          queryEvaluacionSE.data.referenciavecinal1_se || "",
        referenciavecinal2_se:
          queryEvaluacionSE.data.referenciavecinal2_se || "",
        titularcuentabanco_se:
          queryEvaluacionSE.data.titularcuentabanco_se || "",
        tiempolibre_se: queryEvaluacionSE.data.tiempolibre_se || "",
        fuma_se: queryEvaluacionSE.data.fuma_se || "",
        cuantofuma_se: queryEvaluacionSE.data.cuantofuma_se || "",
        toma_se: queryEvaluacionSE.data.toma_se || "",
        cuantotoma_se: queryEvaluacionSE.data.cuantotoma_se || "",
        ultimavez_se: queryEvaluacionSE.data.ultimavez_se || "",
        consumedrogas_se: queryEvaluacionSE.data.consumedrogas_se || "",
        aniolaboral_se: queryEvaluacionSE.data.aniolaboral_se || "",
        externo1_se: queryEvaluacionSE.data.externo1_se || "",
        tiempolaborando1_se: queryEvaluacionSE.data.tiempolaborando1_se || "",
        tiempolaborando2_se: queryEvaluacionSE.data.tiempolaborando2_se || "",
        supervision_se: queryEvaluacionSE.data.supervision_se || "",
        telcoordinadora_se: queryEvaluacionSE.data.telcoordinadora_se || "",
        telsinexito_se: queryEvaluacionSE.data.telsinexito_se || "",
        externo2_se: queryEvaluacionSE.data.externo2_se || "",
        observaciones_se: queryEvaluacionSE.data.observaciones_se || "",
        drogasdescripcion_se: queryEvaluacionSE.data.drogasdescripcion_se || "",
        cuentaconfamiliares_se:
          queryEvaluacionSE.data.cuentaconfamiliares_se || "",
        comollego_se: queryEvaluacionSE.data.comollego_se || "",
        cuentasbancarias_se: queryEvaluacionSE.data.cuentasbancarias_se || "",
        cuantosinmuebles_se: queryEvaluacionSE.data.cuantosinmuebles_se || "",
        titulospropiedad_se: queryEvaluacionSE.data.titulospropiedad_se || "",
        comoadquirio1_se: queryEvaluacionSE.data.comoadquirio1_se || "",
        descripcionvehiculos: queryEvaluacionSE.data.descripcionvehiculos || "",
        titulosvehiculos_se: queryEvaluacionSE.data.titulosvehiculos_se || "",
        comoadquirio2_se: queryEvaluacionSE.data.comoadquirio2_se || "",
        procesospenales_se: queryEvaluacionSE.data.procesospenales_se || "",
        descripcionpenales_se:
          queryEvaluacionSE.data.descripcionpenales_se || "",
        anotedirecciones_se: queryEvaluacionSE.data.anotedirecciones_se || "",
        practicadeporte_se: queryEvaluacionSE.data.practicadeporte_se || "",
        cualdeporte_se: queryEvaluacionSE.data.cualdeporte_se || "",
        religionpertenece_se: queryEvaluacionSE.data.religionpertenece_se || "",
        estadosalud_se: queryEvaluacionSE.data.estadosalud_se || "",
        inmuebleperteece_se: queryEvaluacionSE.data.inmuebleperteece_se || "",
        relacionvecinos_se: queryEvaluacionSE.data.relacionvecinos_se || "",
        inpuestodemanda_se: queryEvaluacionSE.data.inpuestodemanda_se || "",
        motivodemanda_se: queryEvaluacionSE.data.motivodemanda_se || "",
        aniodemanda_se: queryEvaluacionSE.data.aniodemanda_se || "",
        tienecredito_se: queryEvaluacionSE.data.tienecredito_se || "",
        tipocredito_se: queryEvaluacionSE.data.tipocredito_se || "",
        autopaga_se: queryEvaluacionSE.data.autopaga_se || "",
        pagomensuales_se: queryEvaluacionSE.data.pagomensuales_se || "",
        tarjetaspaga_se: queryEvaluacionSE.data.tarjetaspaga_se || "",
        pagomensualtarjetas_se:
          queryEvaluacionSE.data.pagomensualtarjetas_se || "",
        tieneadeudoscredito_se:
          queryEvaluacionSE.data.tieneadeudoscredito_se || "",
        institucioncredito_se:
          queryEvaluacionSE.data.institucioncredito_se || "",
        cuantopagacredito_se: queryEvaluacionSE.data.cuantopagacredito_se || "",
        tienecreditofonacot_se:
          queryEvaluacionSE.data.tienecreditofonacot_se || "",
        cuantopagafonacot_se: queryEvaluacionSE.data.cuantopagafonacot_se || "",
        retrasocredito_se: queryEvaluacionSE.data.retrasocredito_se || "",
        burocredito_se: queryEvaluacionSE.data.burocredito_se || "",
        motivoburo_se: queryEvaluacionSE.data.motivoburo_se || "",
        ingresomensual2_se: queryEvaluacionSE.data.ingresomensual2_se || "",
        nombreprimaria_se: queryEvaluacionSE.data.nombreprimaria_se || "",
        ciudadprimaria_se: queryEvaluacionSE.data.ciudadprimaria_se || "",
        aniosprimaria_se: queryEvaluacionSE.data.aniosprimaria_se || "",
        periodoprimaria_se: queryEvaluacionSE.data.periodoprimaria_se || "",
        certificadoprimaria_se:
          queryEvaluacionSE.data.certificadoprimaria_se || "",
        nombresecundaria_se: queryEvaluacionSE.data.nombresecundaria_se || "",
        ciudadsecundaria_se: queryEvaluacionSE.data.ciudadsecundaria_se || "",
        aniossecundaria_se: queryEvaluacionSE.data.aniossecundaria_se || "",
        periodosecundaria_se: queryEvaluacionSE.data.periodosecundaria_se || "",
        certificadosecundaria_se:
          queryEvaluacionSE.data.certificadosecundaria_se || "",
        nombrebachillerato_se:
          queryEvaluacionSE.data.nombrebachillerato_se || "",
        ciudadbachillerato_se:
          queryEvaluacionSE.data.ciudadbachillerato_se || "",
        aniosbachillerato_se: queryEvaluacionSE.data.aniosbachillerato_se || "",
        periodobachillerato_se:
          queryEvaluacionSE.data.periodobachillerato_se || "",
        certificadobachillerato_se:
          queryEvaluacionSE.data.certificadobachillerato_se || "",
        nombrelicenciatura_se:
          queryEvaluacionSE.data.nombrelicenciatura_se || "",
        ciudadlicenciatura_se:
          queryEvaluacionSE.data.ciudadlicenciatura_se || "",
        anioslicenciatura_se: queryEvaluacionSE.data.anioslicenciatura_se || "",
        periodolicenciatura_se:
          queryEvaluacionSE.data.periodolicenciatura_se || "",
        certificadolicenciatura_se:
          queryEvaluacionSE.data.certificadolicenciatura_se || "",
        estudiaactualmente_se:
          queryEvaluacionSE.data.estudiaactualmente_se || "",
        dondeestudia_se: queryEvaluacionSE.data.dondeestudia_se || "",
        horarioestudio_se: queryEvaluacionSE.data.horarioestudio_se || "",
        indicarespecialidad_se:
          queryEvaluacionSE.data.indicarespecialidad_se || "",
        notaestudio_se: queryEvaluacionSE.data.notaestudio_se || "",
      });
    }
  }, [queryEvaluacionSE.data, reset]);

  return (
    <div className="max-w-[800px] mx-auto p-4 bg-white">
      {/* Marca de agua */}
      <div className="absolute inset-0 flex justify-center items-center pointer-events-none z-0">
        <div
          className="text-blue-500 text-9xl font-bold transform rotate-[-48deg]"
          style={{ opacity: 0.1 }}
        >
          CONFIDENCIAL
        </div>
      </div>
      {/* Header */}
      <HeaderPrint titulo={tituloFormulario} />
      {/* Título del formulario */}
      <div id="headerContent" className="text-center">
        <h1
          className="text-black text-xl font-bold py-3 px-8 rounded-b-md inline-block flex justify-center transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer"
          style={{
            backgroundImage: `url(${fotoMapa})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {tituloFormulario}
        </h1>
      </div>
      <div className="space-y-1 p-1 mt-2">
        <div className="grid grid-cols-3 gap-2">
          <div className="col-span-1 flex items-center">
            <Label htmlFor="fecha_conclusionps" className="mr-2">
              FECHA:
            </Label>
            <Controller
              name="fecha_conclusionps"
              control={control}
              defaultValue=""
              render={({ field }) => {
                const formatDate = (dateString: string): string => {
                  if (!dateString) return "";
                  const date = new Date(dateString + "T00:00:00");
                  return isNaN(date.getTime())
                    ? ""
                    : date.toLocaleDateString("es-ES", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      });
                };

                return (
                  <TextInput
                    id="fecha_evaluacionse"
                    name="fecha_evaluacionse"
                    value={
                      field.value ||
                      (queryFechaSE.data && queryFechaSE.data.length > 0
                        ? formatDate(queryFechaSE.data[0]?.fecha_evaluacionse)
                        : "")
                    }
                    disabled={true}
                  />
                );
              }}
            />
          </div>
          <div className="col-span-2">
            <Label htmlFor="nombre">NOMBRE:</Label>
            <TextInput
              id="nombre"
              name="nombre"
              value={`${queryEvaluado.data?.nombre || ""} ${
                queryEvaluado.data?.apellido_paterno || ""
              } ${queryEvaluado.data?.apellido_materno || ""}`}
              onChange={handleInputChange}
              disabled={true}
            />
          </div>
          {/* Campo para RFC */}
          <div className="col-span-1">
            <Label htmlFor="rfc">RFC:</Label>
            <TextInput
              id="rfc"
              name="rfc"
              onChange={handleInputChange}
              value={queryEvaluado.data?.rfc || ""}
              disabled={true}
            />
          </div>
          {/* Edad */}
          <div className="col-span-1">
            <Label htmlFor="edad">EDAD:</Label>
            <TextInput
              id="edad"
              name="edad"
              value={edad !== null ? edad.toString() : ""}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="sexo">SEXO:</Label>
            <TextInput
              id="sexo"
              name="sexo"
              value={generoTexto}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="estadoCivil">ESTADO CIVIL:</Label>
            <TextInput
              id="estadoCivil"
              name="estadoCivil"
              onChange={handleInputChange}
              value={`${queryEvaluado.data?.estado_civil || ""}`}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="escolaridad">ESCOLARIDAD:</Label>
            <TextInput
              id="escolaridad"
              name="escolaridad"
              onChange={handleInputChange}
              value={`${queryEvaluado.data?.escolaridad || ""}`}
              disabled={true}
            />
          </div>
          <div className="col-span-1 flex items-center">
            <Label htmlFor="fechaNacimiento" className="mr-2">
              FECHA DE NACIMIENTO:
            </Label>
            <TextInput
              id="fechaNacimiento"
              name="fechaNacimiento"
              value={`${queryEvaluado.data?.fecha_nacimiento || ""}`}
              disabled={true}
              type="date"
              onChange={handleInputChange}
              className="w-32"
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="curp">CURP:</Label>
            <TextInput
              id="curp"
              name="curp"
              onChange={handleInputChange}
              value={queryEvaluado.data?.curp || ""}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="empresa">EMPRESA:</Label>
            <TextInput
              id="empresa_id"
              name="empresa"
              value={queryEvaluado.data?.empresa_id?.nombre || ""}
              onChange={handleInputChange}
              disabled={true}
            />
          </div>
        </div>
      </div>
      <div className="space-y-6 p-6 bg-gray-50 rounded-lg shadow-md">
        {/* Tabla */}
        <div className="w-full overflow-x-auto">
          <table className="w-auto bg-white border-2 border-gray-500 rounded-lg overflow-hidden">
            <thead>
              <tr className="bg-blue-500 text-black">
                <th
                  colSpan={3}
                  className="py-2 px-3 border border-gray-300 text-center text-sm"
                >
                  CUESTIONARIO INVESTIGACIÓN SOCIOECONÓMICA
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-1 px-2 border border-gray-300 text-center text-xs">
                  Estado Civil
                </th>
                <th className="py-1 px-2 border border-gray-300 text-center text-xs">
                  En caso de estar casado, indique el régimen matrimonial
                </th>
                <th className="py-1 px-2 border border-gray-300 text-center text-xs">
                  ¿Cuántos años tiene de casado?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-1 px-2 border border-gray-300">
                  <textarea
                    className="w-full p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    value={
                      queryEvaluado.data?.estado_civil
                        ? queryEvaluado.data.estado_civil
                            .charAt(0)
                            .toUpperCase() +
                          queryEvaluado.data.estado_civil.slice(1)
                        : ""
                    }
                    placeholder="Estado Civil"
                    disabled={true}
                  />
                </td>
                <td className="py-1 px-2 border border-gray-300">
                  <textarea
                    value={`${queryEvaluacionSE.data?.regimen_se}`}
                    disabled={true}
                    className="w-full p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="Régimen..."
                  />
                </td>
                <td className="py-1 px-2 border border-gray-300">
                  <textarea
                    disabled={true}
                    value={`${queryEvaluacionSE.data?.anioscasado_se || ""}`}
                    className="w-full p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="¿Cuantos años?"
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-1 px-2 border border-gray-300 text-center text-xs">
                  ¿Cuántos hijos tiene y que edades tienen?
                </th>
                <th className="py-1 px-2 border border-gray-300 text-center text-xs">
                  ¿Cuántos dependientes económicos tiene y quiénes son?
                </th>
                <th className="py-1 px-2 border border-gray-300 text-center text-xs">
                  Empresa en la que labora, antigüedad y a qué área pertenece
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-1 px-2 border border-gray-300">
                  <textarea
                    disabled={true}
                    value={buildIntegrantesText()}
                    className="w-full h-[60px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="Integrantes"
                    readOnly
                  />
                </td>
                <td className="py-1 px-2 border border-gray-300">
                  <textarea
                    value={`${queryEvaluacionSE.data?.numdependientes_se}, ${queryEvaluacionSE.data?.quienesdependen_se}`}
                    disabled={true}
                    className="w-full h-[60px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="Número de dependientes"
                  />
                </td>
                <td className="py-1 px-2 border border-gray-300">
                  <textarea
                    id="describe"
                    disabled={true}
                    value={`${
                      queryEvaluado.data?.empresa_id?.nombre || "" || ""
                    } con ${
                      queryEvaluado.data?.antiguedad || ""
                    } de antigüedad, en el área de ${
                      queryEvaluado.data?.puesto || ""
                    }
          `}
                    className="w-full h-[60px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="Descripción"
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-1 px-2 border border-gray-300 text-center text-xs">
                  Fecha de ingreso a la empresa en la que actualmente labora
                </th>
                <th className="py-1 px-2 border border-gray-300 text-center text-xs">
                  ¿Cuenta con familiares laborando en la empresa donde está
                  actualmente?
                </th>
                <th className="py-1 px-2 border border-gray-300 text-center text-xs">
                  ¿Cómo se enteró del empleo?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-1 px-2 border border-gray-300">
                  <textarea
                    value={`Ingresó el ${
                      queryEvaluado.data?.fecha_ingreso
                        ? new Date(
                            queryEvaluado.data.fecha_ingreso
                          ).toLocaleDateString("es-ES")
                        : ""
                    }
              `}
                    disabled={true}
                    className="w-full h-[60px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="Razón de identificación"
                  />
                </td>
                <td className="py-1 px-2 border border-gray-300">
                  <textarea
                    id="cuentaconfamiliares_se"
                    disabled={true}
                    value={`${
                      queryEvaluacionSE.data?.cuentaconfamiliares_se || ""
                    }`}
                    className="w-full h-[60px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="¿Cuenta con familiares en la empresa?"
                  />
                </td>
                <td className="py-1 px-2 border border-gray-300">
                  <textarea
                    value={`${queryEvaluacionSE.data?.enterovacante_se}`}
                    disabled={true}
                    className="w-full h-[60px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="¿Como se enteró?"
                  />
                </td>
              </tr>
            </thead>
          </table>
        </div>
        <div className="mt-2">
          <div className="flex items-center gap-2">
            <Label
              htmlFor="nombreFirma"
              className="text-sm font-semibold whitespace-nowrap ml-auto"
            >
              Nombre y Firma del Evaluado:
            </Label>
            <TextInput
              id="nombreFirma"
              name="nombreFirma"
              className="w-64 rounded-md py-1 text-sm"
            />
          </div>
        </div>
        <div className="w-full overflow-x-auto">
          <table className="w-auto bg-white border border-gray-300 rounded-lg overflow-hidden">
            <thead>
              <tr className="bg-blue-500 text-black">
                <th
                  colSpan={3}
                  className="py-2 px-3 border-b text-center text-sm"
                >
                  CUESTIONARIO PARA INVESTIGACIÓN SOCIOECONÓMICA
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-1 px-2 border-b text-center text-xs">
                  ¿Cómo llego y quien le recomendó laborar en esa empresa?
                </th>
                <th className="py-1 px-2 border-b text-center text-xs">
                  ¿Cuánto asciende su ingreso mensual familiar y como este
                  compuesto, incluyendo el de su esposa(o) de ser el caso, así
                  como ingresos extras por conceptos de alquiler u otros?
                </th>
                <th className="py-1 px-2 border-b text-center text-xs">
                  ¿Cuáles son sus egresos mensuales familiares y como este
                  compuesto, incluyendo el de su esposa de ser el caso,
                  incluyendo deudas, gastos del hogar, diversiones etc.?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-1 px-2 border-b">
                  <textarea
                    id="comollego_se"
                    value={`Llego por ${queryEvaluacionSE.data?.comollego_se} y ${queryEvaluacionSE.data?.recomendo_se} lo recomendó`}
                    disabled={true}
                    className="w-full h-[150px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    aria-label="comollego_se"
                    placeholder="¿Cómo llegó?"
                  />
                </td>
                <td className="py-1 px-2 border-b">
                  <textarea
                    value={`Su ingreso familiar asciende a $ ${queryEvaluacionSE.data?.ingresomensual_se} y está compuesto por ${queryEvaluacionSE.data?.compuestopor_se}, el ingreso de su esposa asciende a $ ${queryEvaluacionSE.data?.ingresoesposa_se}, asi como sus ingresos extras son de $ ${queryEvaluacionSE.data?.ingresosextra_se}`}
                    disabled={true}
                    className="w-full h-[150px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    aria-label="ingresomensual_se"
                    placeholder="Ingresos"
                  />
                </td>
                <td className="py-1 px-2 border-b">
                  <textarea
                    id="egresosfam_se"
                    value={`Sus egresos familiares son de $ ${queryEvaluacionSE.data?.egresosfam_se} y está compuesto por ${queryEvaluacionSE.data?.compuestosde_se}, el egreso de su esposa es de $ ${queryEvaluacionSE.data?.esposaegreso_se}, asi como sus egresos extras son de $ ${queryEvaluacionSE.data?.deudasascienden1_se}`}
                    disabled={true}
                    className="w-full h-[150px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="Egresos mensuales familiares"
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-1 px-2 border-b text-center text-xs">
                  ¿A cuánto ascienden sus deudas?
                </th>
                <th className="py-1 px-2 border-b text-center text-xs">
                  ¿Mencione las cuentas bancarias de las que Usted es titular?
                </th>
                <th className="py-1 px-2 border-b text-center text-xs">
                  ¿Cuántos inmuebles propios o en sociedad posee?, descríbalos,
                  ¿Con que títulos de propiedad cuenta y como los adquirió?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-1 px-2 border-b">
                  <textarea
                    id="deudasascienden2_se"
                    value={`$ ${queryEvaluacionSE.data?.deudasascienden2_se}`}
                    disabled={true}
                    className="w-full h-[80px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="Deudas..."
                  />
                </td>
                <td className="py-1 px-2 border-b">
                  <textarea
                    value={`${queryEvaluacionSE.data?.cuentasbancarias_se}`}
                    disabled={true}
                    className="w-full h-[80px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="Cuentas Bancarias"
                  />
                </td>
                <td className="py-1 px-2 border-b">
                  <textarea
                    value={`Tiene ${queryEvaluacionSE.data?.cuantosinmuebles_se} propiedades y el titulo que posee es de ${queryEvaluacionSE.data?.titulospropiedad_se} y lo adquirió ${queryEvaluacionSE.data?.comoadquirio1_se}`}
                    disabled={true}
                    className="w-full h-[80px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="¿Cuantos Inmuebles?"
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-1 px-2 border-b text-center text-xs">
                  ¿Cuántos vehículos posee?, descríbalos, ¿Con que títulos de
                  propiedad cuenta y como los adquirió?
                </th>
                <th className="py-1 px-2 border-b text-center text-xs">
                  ¿Cuenta con procesos penales o procedimientos
                  administrativos?, en caso de que si, descríbalos
                </th>
                <th className="py-1 px-2 border-b text-center text-xs">
                  ¿Escriba el domicilio donde habita actualmente?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-1 px-2 border-b">
                  <textarea
                    id="cuantosvehiculos_se"
                    value={`Tiene ${queryEvaluacionSE.data?.cuantosvehiculos_se} vehiculos y son ${queryEvaluacionSE.data?.descripcionvehiculos} y el titulo que posee es de ${queryEvaluacionSE.data?.titulosvehiculos_se} y los adquirió ${queryEvaluacionSE.data?.comoadquirio2_se}`}
                    disabled={true}
                    className="w-full h-[150px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="¿Cuántos?"
                  />
                </td>
                <td className="py-1 px-2 border-b">
                  <textarea
                    value={`${
                      queryEvaluacionSE.data?.procesospenales_se === "true"
                        ? "Sí"
                        : "No"
                    }, ${queryEvaluacionSE.data?.descripcionpenales_se}`}
                    disabled={true}
                    className="w-full h-[150px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="¿Lo está?"
                  />
                </td>
                <td className="py-1 px-2 border-b">
                  <Controller
                    name="domicilio"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <textarea
                        id="domicilio"
                        value={`${queryEvaluado.data?.calle || ""}, ${
                          queryEvaluado.data?.numero_exterior || ""
                        }, ${queryEvaluado.data?.colonia || ""}, ${
                          queryEvaluado.data?.codigo_postal || ""
                        }, ${queryEvaluado.data?.municipio || ""}, ${
                          queryEvaluado.data?.estado || ""
                        }, ${queryEvaluado.data?.pais || ""}`}
                        disabled={true}
                        className="w-full h-[150px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                        placeholder="Domicilio..."
                      />
                    )}
                  />
                </td>
              </tr>
            </thead>
          </table>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <div className="mt-2">
          <div className="flex items-center gap-2">
            <Label
              htmlFor="nombreFirma"
              className="text-sm font-semibold whitespace-nowrap ml-auto"
            >
              Nombre y Firma del Evaluado:
            </Label>
            <TextInput
              id="nombreFirma"
              name="nombreFirma"
              className="w-64 rounded-md py-1 text-sm"
            />
          </div>
        </div>
        <div className="w-full overflow-x-auto">
          <table className="w-auto bg-white border border-gray-300 rounded-lg overflow-hidden">
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-1 px-2 border-b text-center text-xs">
                  Anote las direcciones
                </th>
                <th className="py-1 px-2 border-b text-center text-xs">
                  Anote dos referencias vecinales
                </th>
                <th className="py-1 px-2 border-b text-center text-xs">
                  ¿Qué hace en sus tiempos libres?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-1 px-2 border-b">
                  <textarea
                    value={`${queryEvaluacionSE.data?.anotedirecciones_se}`}
                    disabled={true}
                    className="w-full h-[100px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="Direcciones..."
                  />
                </td>
                <td className="py-1 px-2 border-b">
                  <textarea
                    value={`${queryEvaluacionSE.data?.referenciavecinal1_se} y ${queryEvaluacionSE.data?.referenciavecinal2_se}`}
                    disabled={true}
                    className="w-full h-[100px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="Referencia..."
                  />
                </td>
                <td className="py-1 px-2 border-b">
                  <textarea
                    value={`${queryEvaluacionSE.data?.tiempolibre_se}`}
                    disabled={true}
                    className="w-full h-[100px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="¿Que hace en su tiempo libre?"
                  />
                </td>
              </tr>
            </thead>
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-1 px-2 border-b text-center text-xs">
                  ¿Practica algún deporte? (Si/No) ¿Cuál?
                </th>
                <th className="py-1 px-2 border-b text-center text-xs">
                  ¿A que religión pertenece?
                </th>
                <th className="py-1 px-2 border-b text-center text-xs">
                  ¿Cómo considera su estado de salud y por qué?
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-1 px-2 border-b">
                  <textarea
                    value={`${
                      queryEvaluacionSE.data?.practicadeporte_se === "true"
                        ? "Sí"
                        : "No"
                    }, ${queryEvaluacionSE.data?.cualdeporte_se}`}
                    disabled={true}
                    className="w-full h-[60px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="¿Que hace en su tiempo libre?"
                  />
                </td>
                <td className="py-1 px-2 border-b">
                  <textarea
                    value={`${queryEvaluacionSE.data?.religionpertenece_se}`}
                    disabled={true}
                    className="w-full h-[60px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="¿Que religión?"
                  />
                </td>
                <td className="py-1 px-2 border-b">
                  <textarea
                    value={`${queryEvaluacionSE.data?.estadosalud_se}, ${queryEvaluacionSE.data?.derivado_se}`}
                    disabled={true}
                    className="w-full h-[60px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="Estado de salud..."
                  />
                </td>
              </tr>
            </thead>
          </table>
        </div>
        <div className="w-full overflow-x-auto">
          <table
            className="min-w-full bg-white border border-gray-300 rounded-lg overflow-hidden"
            style={{ tableLayout: "fixed" }}
          >
            {/* Encabezado principal */}
            <thead>
              <tr className="bg-blue-500 text-black">
                <th colSpan={3} className="py-3 px-4 border-b text-center">
                  CUESTIONARIO PARA INVESTIGACIÓN SOCIOECONÓMICA
                </th>
              </tr>
            </thead>

            {/* Encabezado secundario */}
            <thead>
              <tr className="bg-blue-200 text-black">
                <th colSpan={3} className="py-2 px-4 border-b text-center">
                  Elabore un croquis de su domicilio actual, entre que calles y
                  referencias
                </th>
              </tr>
            </thead>
          </table>
        </div>

        {/* Croquis */}
        <div className="mt-4 mb-4 w-full">
          <div className="flex justify-center mt-2">
            <img
              src={imageUrl}
              alt="Croquis"
              className="w-full max-w-[800px] h-auto border-2 border-gray-300 rounded-lg"
            />
          </div>
        </div>
        <div className="mt-2">
          <div className="flex items-center gap-2">
            <Label
              htmlFor="nombreFirma"
              className="text-sm font-semibold whitespace-nowrap ml-auto"
            >
              Nombre y Firma del Evaluado:
            </Label>
            <TextInput
              id="nombreFirma"
              name="nombreFirma"
              className="w-64 rounded-md py-1 text-sm"
            />
          </div>
        </div>
        <div className="w-full overflow-x-auto">
          <table className="w-auto bg-white border border-gray-300 rounded-lg overflow-hidden">
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-1 px-2 border-b text-center text-xs">
                  ¿Cuánto tiempo tiene viviendo en ese inmueble?
                </th>
                <th className="py-1 px-2 border-b text-center text-xs">
                  ¿A quién pertenece el inmueble donde habita actualmente?
                </th>
                <th className="py-1 px-2 border-b text-center text-xs">
                  ¿Cómo es la relación que lleva con sus vecinos?
                </th>
              </tr>
            </thead>

            {/* Textareas para las preguntas sobre el inmueble */}
            <tbody>
              <tr className="text-black">
                <td className="py-1 px-2 border-b">
                  <textarea
                    value={`${queryEvaluacionSE.data?.tiempoviviendo_se} años`}
                    disabled={true}
                    className="w-full h-[60px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="Tiempo en el inmueble"
                  />
                </td>
                <td className="py-1 px-2 border-b">
                  <textarea
                    value={`${queryEvaluacionSE.data?.inmuebleperteece_se}`}
                    disabled={true}
                    className="w-full h-[60px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="Propietario del inmueble"
                  />
                </td>
                <td className="py-1 px-2 border-b">
                  <textarea
                    value={`${queryEvaluacionSE.data?.relacionvecinos_se}`}
                    disabled={true}
                    className="w-full h-[60px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="Relación con vecinos"
                  />
                </td>
              </tr>
            </tbody>

            {/* Preguntas sobre hábitos */}
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-1 px-2 border-b text-center text-xs">
                  Fuma, ¿Cuántos cigarros al día aproximadamente?
                </th>
                <th className="py-1 px-2 border-b text-center text-xs">
                  Consume bebidas alcohólicas, ¿Con qué frecuencia y cuándo fue
                  la última vez?
                </th>
                <th className="py-1 px-2 border-b text-center text-xs">
                  ¿Ha consumido o consume algún tipo de droga?
                </th>
              </tr>
            </thead>

            {/* Textareas para las preguntas sobre hábitos */}
            <tbody>
              <tr className="text-black">
                <td className="py-1 px-2 border-b">
                  <textarea
                    value={`${
                      queryEvaluacionSE.data?.fuma_se === "true" ? "Sí" : "No"
                    }, ${
                      queryEvaluacionSE.data?.cuantofuma_se
                    } cigarros al día`}
                    disabled={true}
                    className="w-full h-[60px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="Fuma"
                  />
                </td>
                <td className="py-1 px-2 border-b">
                  <textarea
                    value={`${
                      queryEvaluacionSE.data?.toma_se === "true" ? "Sí" : "No"
                    }, ${
                      queryEvaluacionSE.data?.cuantotoma_se
                    }, siendo la última vez el ${
                      queryEvaluacionSE.data?.ultimavez_se
                        ? new Date(
                            queryEvaluacionSE.data.ultimavez_se + "T00:00:00"
                          ).toLocaleDateString("es-ES")
                        : "Fecha no disponible"
                    }`}
                    disabled={true}
                    className="w-full h-[60px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="Consumo de alcohol"
                  />
                </td>
                <td className="py-1 px-2 border-b">
                  <textarea
                    value={`${
                      queryEvaluacionSE.data?.consumedrogas_se === "true"
                        ? "Sí"
                        : "No"
                    }`}
                    disabled={true}
                    className="w-full h-[60px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="Consumo de drogas"
                  />
                </td>
              </tr>
            </tbody>

            {/* Preguntas sobre demandas laborales */}
            <thead>
              <tr className="bg-blue-200 text-black">
                <th className="py-1 px-2 border-b text-center text-xs">
                  ¿Ha interpuesto demandas laborales?
                </th>
                <th className="py-1 px-2 border-b text-center text-xs">
                  En caso afirmativo, explique los motivos
                </th>
                <th className="py-1 px-2 border-b text-center text-xs">
                  ¿En qué año fue interpuesta?
                </th>
              </tr>
            </thead>

            {/* Textareas para las preguntas sobre demandas laborales */}
            <tbody>
              <tr className="text-black">
                <td className="py-1 px-2 border-b">
                  <textarea
                    value={`${queryEvaluacionSE.data?.inpuestodemanda_se}`}
                    disabled={true}
                    className="w-full h-[60px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="Demandas laborales"
                  />
                </td>
                <td className="py-1 px-2 border-b">
                  <textarea
                    value={`${queryEvaluacionSE.data?.motivodemanda_se}`}
                    disabled={true}
                    className="w-full h-[60px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="Motivos de las demandas"
                  />
                </td>
                <td className="py-1 px-2 border-b">
                  <textarea
                    value={`${
                      queryEvaluacionSE.data?.aniodemanda_se
                        ? new Date(queryEvaluacionSE.data.aniodemanda_se)
                            .toISOString()
                            .split("T")[0]
                            .split("-")
                            .reverse()
                            .join("/")
                        : ""
                    }`}
                    id="aniodemanda_se"
                    disabled={true}
                    className="w-full h-[60px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify text-xs"
                    placeholder="Año de la demanda"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="w-full overflow-x-auto">
          <table className="w-full bg-white border border-gray-300 rounded-lg overflow-hidden">
            <thead>
              <tr className="bg-blue-500 text-black">
                <th className="py-3 px-4 border-b text-center">
                  INFORMACIÓN DE CRÉDITOS
                </th>
              </tr>
            </thead>

            <tbody>
              <tr className="bg-blue-400 text-black"></tr>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  ¿Tienes algún crédito?
                </th>
              </tr>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <textarea
                    value={`${
                      queryEvaluacionSE.data?.tienecredito_se === "true"
                        ? "Sí"
                        : "No"
                    }`}
                    disabled={true}
                    className="w-full border border-gray-300 rounded-md p-2 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="¿Lo tiene?"
                  />
                </td>
              </tr>
            </tbody>

            {/* Responsabilidad */}
            <tbody>
              <tr className="bg-blue-400 text-black"></tr>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  ¿Qué tipo de crédito es?
                </th>
              </tr>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <div>
                    <textarea
                      value={`${queryEvaluacionSE.data?.tipocredito_se}`}
                      disabled={true}
                      className="w-full border border-gray-300 rounded-md p-2 mt-2 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                      placeholder="Motivos de las demandas"
                    />
                  </div>
                </td>
              </tr>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  Automóvil (es) que está pagando
                </th>
              </tr>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <textarea
                    value={`${queryEvaluacionSE.data?.autopaga_se}`}
                    disabled={true}
                    className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                    placeholder="Auto..."
                  />
                </td>
              </tr>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  Pago (s) Mensual (es)
                </th>
              </tr>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <textarea
                    value={`$ ${queryEvaluacionSE.data?.pagomensuales_se}`}
                    disabled={true}
                    className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                    placeholder="Pago..."
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="mt-2">
          <div className="flex items-center gap-2">
            <Label
              htmlFor="nombreFirma"
              className="text-sm font-semibold whitespace-nowrap ml-auto"
            >
              Nombre y Firma del Evaluado:
            </Label>
            <TextInput
              id="nombreFirma"
              name="nombreFirma"
              className="w-64 rounded-md py-1 text-sm"
            />
          </div>
        </div>
        <br />
        <br />
        <div className="w-full overflow-x-auto">
          <table
            className="min-w-full bg-white border border-gray-300 rounded-lg overflow-hidden"
            style={{ tableLayout: "fixed" }}
          >
            <tbody>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  Tarjetas de crédito que está pagando
                </th>
              </tr>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <textarea
                    value={`${queryEvaluacionSE.data?.tarjetaspaga_se}`}
                    disabled={true}
                    className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                    placeholder="Tarjetas..."
                  />
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  Pago mensual (total) a tarjetas
                </th>
              </tr>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <textarea
                    id="pagomensualtarjetas_se"
                    value={`$ ${queryEvaluacionSE.data?.pagomensualtarjetas_se}`}
                    disabled={true}
                    className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                    placeholder="Pago..."
                  />
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  ¿Tiene adeudos?
                </th>
              </tr>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <textarea
                    value={`${
                      queryEvaluacionSE.data?.tieneadeudoscredito_se === "true"
                        ? "Sí"
                        : "No"
                    }`}
                    disabled={true}
                    className="w-full border border-gray-300 rounded-md p-2 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="¿Tiene?"
                  />
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  ¿Con qué institución tiene el crédito hipotecario?
                </th>
              </tr>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <textarea
                    value={`${queryEvaluacionSE.data?.institucioncredito_se}`}
                    disabled={true}
                    className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                    placeholder="¿Con cual?..."
                  />
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  ¿Cuánto paga?
                </th>
              </tr>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <textarea
                    value={`$ ${queryEvaluacionSE.data?.cuantopagacredito_se}`}
                    disabled={true}
                    className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                    placeholder="¿Cuánto?..."
                  />
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  ¿Tiene crédito FONACOT?
                </th>
              </tr>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <textarea
                    value={`${
                      queryEvaluacionSE.data?.tienecreditofonacot_se === "true"
                        ? "Sí"
                        : "No"
                    }`}
                    disabled={true}
                    className="w-full border border-gray-300 rounded-md p-2 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="¿Tiene?"
                  />
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  ¿Cuánto paga?
                </th>
              </tr>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <textarea
                    value={`$ ${queryEvaluacionSE.data?.cuantopagafonacot_se}`}
                    disabled={true}
                    className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                    placeholder="¿Cuánto?"
                  />
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  ¿Tiene retraso en alguno de los créditos?
                </th>
              </tr>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <textarea
                    value={`${
                      queryEvaluacionSE.data?.retrasocredito_se === "true"
                        ? "Sí"
                        : "No"
                    }`}
                    disabled={true}
                    className="w-full border border-gray-300 rounded-md p-2 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="¿Tiene?"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="mt-2">
          <div className="flex items-center gap-2">
            <Label
              htmlFor="nombreFirma"
              className="text-sm font-semibold whitespace-nowrap ml-auto"
            >
              Nombre y Firma del Evaluado:
            </Label>
            <TextInput
              id="nombreFirma"
              name="nombreFirma"
              className="w-64 rounded-md py-1 text-sm"
            />
          </div>
        </div>
        <div className="w-full overflow-x-auto">
          <table
            className="min-w-full bg-white border border-gray-300 rounded-lg overflow-hidden"
            style={{ tableLayout: "fixed" }}
          >
            <tbody>
              <tr className="bg-blue-200 text-black">
                <th className="py-2 px-4 border-b text-center">
                  ¿Estás en buró de crédito? Especifique
                </th>
              </tr>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <textarea
                    value={`${
                      queryEvaluacionSE.data?.burocredito_se === "true"
                        ? "Sí"
                        : "No"
                    }`}
                    disabled={true}
                    className="w-full border border-gray-300 rounded-md p-2 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="¿Lo está?"
                  />
                  <textarea
                    id="motivoburo_se"
                    value={`${queryEvaluacionSE.data?.motivoburo_se}`}
                    disabled={true}
                    className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-justify"
                    placeholder="Especifique..."
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="w-full overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-300 rounded-lg overflow-hidden">
            <thead>
              <tr className="bg-blue-500 text-black">
                <th className="py-3 px-4 border-b text-center">
                  DISTRIBUCIÓN DE GASTOS
                </th>
              </tr>
            </thead>
            <thead>
              <tr className="text-black">
                <td className="py-2 px-4 border-b">
                  <span>
                    <strong>INGRESOS ESTIMADOS EN FAMILIA:</strong> $
                    <label
                      htmlFor="edad"
                      className="text-gray-800 font-medium inline-block"
                    >{`${queryEvaluacionSE.data?.ingresomensual_se}`}</label>
                    .00 / $
                    <label
                      htmlFor="edad"
                      className="text-gray-800 font-medium inline-block"
                    >{`${queryEvaluacionSE.data?.ingresomensual2_se}`}</label>
                    .00, ingreso de su pareja y / $
                    <label
                      htmlFor="edad"
                      className="text-gray-800 font-medium inline-block"
                    >{`${queryEvaluacionSE.data?.ingresoesposa_se}`}</label>
                    .00 ingreso del evaluado.
                  </span>
                </td>
              </tr>
            </thead>
          </table>
        </div>
        {/* Tabla de distribución mensual de gastos */}
        <div className="w-full overflow-x-auto">
          <table className="table-auto border-collapse border border-gray-300 w-full">
            {/* Header */}
            <thead>
              <tr>
                <th
                  className="border border-gray-300 px-4 py-2 bg-gray-100 text-center text-gray-700 font-semibold"
                  colSpan={2}
                >
                  DISTRIBUCION MENSUAL DE GASTOS
                </th>
              </tr>
            </thead>
            <tbody>
              {/* Filas */}
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Alimentación
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    value={`$ ${queryEvaluacionSE.data?.gastoalimentacion_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Vestido y Calzado
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    value={`$ ${queryEvaluacionSE.data?.gastovestido_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Gasolina
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    value={`$ ${queryEvaluacionSE.data?.gastogasolina_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Transporte
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    value={`$ ${queryEvaluacionSE.data?.gastotransporte_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Teléfono
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    value={`$ ${queryEvaluacionSE.data?.gastotelefono_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Diversiones
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    value={`$ ${queryEvaluacionSE.data?.gastodiversiones_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Autofinanciamiento
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    id="gastoautofinanciamiento_se"
                    value={`$ ${queryEvaluacionSE.data?.gastoautofinanciamiento_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Otros
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    value={`$ ${queryEvaluacionSE.data?.gastootros1_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <div className="mt-2">
              <div className="flex items-center gap-2">
                <Label
                  htmlFor="nombreFirma"
                  className="text-sm font-semibold whitespace-nowrap ml-auto"
                >
                  Nombre y Firma del Evaluado:
                </Label>
                <TextInput
                  id="nombreFirma"
                  name="nombreFirma"
                  className="w-64 rounded-md py-1 text-sm"
                />
              </div>
            </div>
          </div>
          <table className="table-auto border-collapse border border-gray-300 w-full">
            <tbody>
              {/* Filas */}
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Hipoteca
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    value={`$ ${queryEvaluacionSE.data?.gastohipoteca_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Renta
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    value={`$ ${queryEvaluacionSE.data?.gastorenta_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Colegiaturas
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    value={`$ ${queryEvaluacionSE.data?.gastocolegiaturas_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Servicios
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    value={`$ ${queryEvaluacionSE.data?.gastoservicios_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Deudas
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    value={`$ ${queryEvaluacionSE.data?.gastodeudas_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Inversiones
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    value={`$ ${queryEvaluacionSE.data?.gastoinversiones_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Pensión Alimenticia
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    id="gastopension_se"
                    value={`$ ${queryEvaluacionSE.data?.gastopension_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Otros
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    id="gastootros2_se"
                    value={`$ ${queryEvaluacionSE.data?.gastootros2_se}`}
                    disabled={true}
                    type="numeric"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$1,000"
                  />
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2 text-gray-700">
                  Total
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  <input
                    id="gastototal_se"
                    disabled={true}
                    type="text"
                    className="border border-gray-300 px-4 py-2 rounded-md w-auto inline-block text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="$0.00"
                    value={`$ ${[
                      "gastoalimentacion_se",
                      "gastovestido_se",
                      "gastogasolina_se",
                      "gastotransporte_se",
                      "gastotelefono_se",
                      "gastodiversiones_se",
                      "gastoautofinanciamiento_se",
                      "gastootros1_se",
                      "gastohipoteca_se",
                      "gastorenta_se",
                      "gastocolegiaturas_se",
                      "gastoservicios_se",
                      "gastodeudas_se",
                      "gastoinversiones_se",
                      "gastopension_se",
                      "gastootros2_se",
                    ]
                      .map((name) => parseFloat(getValues(name)) || 0)
                      .reduce((acc, value) => acc + value, 0)
                      .toFixed(2)}`}
                    readOnly
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="w-full overflow-x-auto">
          <table className="w-auto bg-white border border-gray-300 rounded-lg overflow-hidden">
            <thead>
              <tr className="bg-blue-500 text-black text-center">
                <th colSpan={6} className="py-1 px-2 border-b text-sm">
                  ESCOLARIDAD
                </th>
              </tr>
            </thead>
            <thead className="bg-gray-100 text-xs">
              <tr>
                <th className="border border-gray-300 px-1 py-1 text-left font-semibold">
                  NIVEL
                </th>
                <th className="border border-gray-300 px-1 py-1 text-left font-semibold">
                  INSTITUCIÓN
                </th>
                <th className="border border-gray-300 px-1 py-1 text-left font-semibold">
                  CIUDAD
                </th>
                <th className="border border-gray-300 px-1 py-1 text-left font-semibold">
                  AÑOS
                </th>
                <th className="border border-gray-300 px-1 py-1 text-left font-semibold">
                  PERIODO
                </th>
                <th className="border border-gray-300 px-1 py-1 text-left font-semibold">
                  CERTIFICADO
                </th>
              </tr>
            </thead>
            <tbody className="text-xs">
              {/* PRIMARIA */}
              <tr>
                <td className="border border-gray-300 px-1 py-1">PRIMARIA</td>
                <td className="border border-gray-300 px-1 py-1">
                  <input
                    id="nombreprimaria_se"
                    value={`${queryEvaluacionSE.data?.nombreprimaria_se}`}
                    disabled
                    type="text"
                    className="w-32 border border-gray-300 rounded-md p-1 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="Institución"
                  />
                </td>
                <td className="border border-gray-300 px-1 py-1">
                  <input
                    value={`${queryEvaluacionSE.data?.ciudadprimaria_se}`}
                    disabled
                    type="text"
                    className="w-24 border border-gray-300 rounded-md p-1 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="Ciudad"
                  />
                </td>
                <td className="border border-gray-300 px-1 py-1">
                  <input
                    value={`${queryEvaluacionSE.data?.aniosprimaria_se}`}
                    disabled
                    type="text"
                    className="w-16 border border-gray-300 rounded-md p-1 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400 text-center"
                    placeholder="Años"
                  />
                </td>
                <td className="border border-gray-300 px-1 py-1">
                  <input
                    id="periodoprimaria_se"
                    value={`${queryEvaluacionSE.data?.periodoprimaria_se}`}
                    disabled
                    type="text"
                    className="w-24 border border-gray-300 rounded-md p-1 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="Periodo"
                  />
                </td>
                <td className="border border-gray-300 px-1 py-1">
                  <input
                    id="certificadoprimaria_se"
                    value={`${queryEvaluacionSE.data?.certificadoprimaria_se}`}
                    disabled
                    type="text"
                    className="w-24 border border-gray-300 rounded-md p-1 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="Certificado"
                  />
                </td>
              </tr>

              {/* SECUNDARIA */}
              <tr>
                <td className="border border-gray-300 px-1 py-1">SECUNDARIA</td>
                <td className="border border-gray-300 px-1 py-1">
                  <input
                    id="nombresecundaria_se"
                    value={`${queryEvaluacionSE.data?.nombresecundaria_se}`}
                    disabled
                    type="text"
                    className="w-32 border border-gray-300 rounded-md p-1 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="Institución"
                  />
                </td>
                <td className="border border-gray-300 px-1 py-1">
                  <input
                    id="ciudadsecundaria_se"
                    value={`${queryEvaluacionSE.data?.ciudadsecundaria_se}`}
                    disabled
                    type="text"
                    className="w-24 border border-gray-300 rounded-md p-1 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="Ciudad"
                  />
                </td>
                <td className="border border-gray-300 px-1 py-1">
                  <input
                    value={`${queryEvaluacionSE.data?.aniossecundaria_se}`}
                    disabled
                    type="text"
                    className="w-16 border border-gray-300 rounded-md p-1 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400 text-center"
                    placeholder="Años"
                  />
                </td>
                <td className="border border-gray-300 px-1 py-1">
                  <input
                    value={`${queryEvaluacionSE.data?.periodosecundaria_se}`}
                    disabled
                    type="text"
                    className="w-24 border border-gray-300 rounded-md p-1 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="Periodo"
                  />
                </td>
                <td className="border border-gray-300 px-1 py-1">
                  <input
                    value={`${queryEvaluacionSE.data?.certificadosecundaria_se}`}
                    disabled
                    type="text"
                    className="w-24 border border-gray-300 rounded-md p-1 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="Certificado"
                  />
                </td>
              </tr>

              {/* BACHILLERATO */}
              <tr>
                <td className="border border-gray-300 px-1 py-1">
                  BACHILLERATO
                </td>
                <td className="border border-gray-300 px-1 py-1">
                  <input
                    value={`${queryEvaluacionSE.data?.nombrebachillerato_se}`}
                    disabled
                    type="text"
                    className="w-32 border border-gray-300 rounded-md p-1 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="Institución"
                  />
                </td>
                <td className="border border-gray-300 px-1 py-1">
                  <input
                    id="ciudadbachillerato_se"
                    value={`${queryEvaluacionSE.data?.ciudadbachillerato_se}`}
                    disabled
                    type="text"
                    className="w-24 border border-gray-300 rounded-md p-1 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="Ciudad"
                  />
                </td>
                <td className="border border-gray-300 px-1 py-1">
                  <input
                    value={`${queryEvaluacionSE.data?.aniosbachillerato_se}`}
                    disabled
                    type="text"
                    className="w-16 border border-gray-300 rounded-md p-1 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400 text-center"
                    placeholder="Años"
                  />
                </td>
                <td className="border border-gray-300 px-1 py-1">
                  <input
                    value={`${queryEvaluacionSE.data?.periodobachillerato_se}`}
                    disabled
                    type="text"
                    className="w-24 border border-gray-300 rounded-md p-1 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="Periodo"
                  />
                </td>
                <td className="border border-gray-300 px-1 py-1">
                  <input
                    value={`${queryEvaluacionSE.data?.certificadobachillerato_se}`}
                    disabled
                    type="text"
                    className="w-24 border border-gray-300 rounded-md p-1 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="Certificado"
                  />
                </td>
              </tr>

              {/* LICENCIATURA */}
              <tr>
                <td className="border border-gray-300 px-1 py-1">
                  LICENCIATURA
                </td>
                <td className="border border-gray-300 px-1 py-1">
                  <input
                    value={`${queryEvaluacionSE.data?.nombrelicenciatura_se}`}
                    disabled
                    type="text"
                    className="w-32 border border-gray-300 rounded-md p-1 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="Institución"
                  />
                </td>
                <td className="border border-gray-300 px-1 py-1">
                  <input
                    value={`${queryEvaluacionSE.data?.ciudadlicenciatura_se}`}
                    disabled
                    type="text"
                    className="w-24 border border-gray-300 rounded-md p-1 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="Ciudad"
                  />
                </td>
                <td className="border border-gray-300 px-1 py-1">
                  <input
                    value={`${queryEvaluacionSE.data?.anioslicenciatura_se}`}
                    disabled
                    type="text"
                    className="w-16 border border-gray-300 rounded-md p-1 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400 text-center"
                    placeholder="Años"
                  />
                </td>
                <td className="border border-gray-300 px-1 py-1">
                  <input
                    value={`${queryEvaluacionSE.data?.periodolicenciatura_se}`}
                    disabled
                    type="text"
                    className="w-24 border border-gray-300 rounded-md p-1 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="Periodo"
                  />
                </td>
                <td className="border border-gray-300 px-1 py-1">
                  <input
                    value={`${queryEvaluacionSE.data?.certificadolicenciatura_se}`}
                    disabled
                    type="text"
                    className="w-24 border border-gray-300 rounded-md p-1 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="Certificado"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <div className="mt-2">
          <div className="flex items-center gap-2">
            <Label
              htmlFor="nombreFirma"
              className="text-sm font-semibold whitespace-nowrap ml-auto"
            >
              Nombre y Firma del Evaluado:
            </Label>
            <TextInput
              id="nombreFirma"
              name="nombreFirma"
              className="w-64 rounded-md py-1 text-sm"
            />
          </div>
        </div>
        <div className="overflow-x-auto">
          <table className="w-auto bg-white border border-gray-300 rounded-lg overflow-hidden">
            <tbody className="text-xs">
              {/* Pregunta: ¿Estudia actualmente? */}
              <tr>
                <td className="border border-gray-300 px-2 py-1 text-gray-700 font-semibold">
                  ¿Estudia actualmente?
                </td>
                <td className="border border-gray-300 px-2 py-1">
                  <input
                    value={`${queryEvaluacionSE.data?.estudiaactualmente_se}`}
                    disabled={true}
                    type="text"
                    className="w-48 border border-gray-300 rounded-md p-1 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="Respuesta"
                  />
                </td>
              </tr>

              {/* Pregunta: ¿En dónde? */}
              <tr>
                <td className="border border-gray-300 px-2 py-1 text-gray-700 font-semibold">
                  ¿En dónde?
                </td>
                <td className="border border-gray-300 px-2 py-1">
                  <input
                    value={`${queryEvaluacionSE.data?.dondeestudia_se}`}
                    disabled={true}
                    type="text"
                    className="w-48 border border-gray-300 rounded-md p-1 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="Lugar de estudio"
                  />
                </td>
              </tr>

              {/* Pregunta: ¿Horario? */}
              <tr>
                <td className="border border-gray-300 px-2 py-1 text-gray-700 font-semibold">
                  ¿Horario?
                </td>
                <td className="border border-gray-300 px-2 py-1">
                  <input
                    value={`${queryEvaluacionSE.data?.horarioestudio_se}`}
                    disabled={true}
                    type="text"
                    className="w-48 border border-gray-300 rounded-md p-1 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="Horario de estudio"
                  />
                </td>
              </tr>

              {/* Nota adicional */}
              <tr>
                <td className="border border-gray-300 px-2 py-1 text-gray-700 font-semibold">
                  En caso de contar con Carrera Técnica y/o Licenciatura,
                  indicar especialidad.
                </td>
                <td className="border border-gray-300 px-2 py-1">
                  <input
                    value={`${queryEvaluacionSE.data?.indicarespecialidad_se}`}
                    disabled={true}
                    type="text"
                    className="w-48 border border-gray-300 rounded-md p-1 text-gray-700 placeholder-gray-500 focus:ring-2 focus:ring-indigo-400"
                    placeholder="Especialidad"
                  />
                </td>
              </tr>
              <tr className="text-black">
                <td colSpan={2} className="py-1 px-2 border-b">
                  <textarea
                    value={`${queryEvaluacionSE.data?.notaestudio_se}`}
                    disabled={true}
                    className="w-full h-[675px] p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    aria-label="notaestudio_se"
                    placeholder="Nota..."
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="mt-2">
          <div className="flex items-center gap-2">
            <Label
              htmlFor="nombreFirma"
              className="text-sm font-semibold whitespace-nowrap ml-auto"
            >
              Nombre y Firma del Evaluado:
            </Label>
            <TextInput
              id="nombreFirma"
              name="nombreFirma"
              className="w-64 rounded-md py-1 text-sm"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
